export default function defaultQBRules() {
    return {
        children: [],
        logicalOperator: 'AND'
    }
}
